// extracted by mini-css-extract-plugin
module.exports = {"logo":"Logo_logo__qjHk5","image":"Logo_image__VCGUx","hidden":"Logo_hidden__5exG9"};